import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResultTypeDTO } from '../../api/plyca-dtos-v2';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../tasks/baseFormComponent/baseForm.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { Configuration } from '../../conf/app.constants';

import { HelpService } from '../../components/common/help/help.service';
import { of, Observable } from 'rxjs';
import { FormConfig } from '../../components/forms/form.objects';
import { tap, finalize } from 'rxjs/operators';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { InfrastructurePlanDTO } from '../../api/dipbad-dtos';
import { ProfileService } from './../../../services/profile.services';
import * as lodash from 'lodash';
import { UserService } from '../../user.service';

export class InfrastructurePlanModel {

  dto: InfrastructurePlanDTO;
  ui: {
  }
}

@Component({
  selector: 'infrastructureplan-form',
  templateUrl: '../../tasks/baseFormComponent/baseForm.template.html'
})
export class InfrastructurePlanComponent
  extends BaseFormComponent<InfrastructurePlanDTO, InfrastructurePlanModel>
  implements OnInit, OnDestroy, AfterContentInit {
  headerService: any;
  private identifier: string;
  public readonly = false;


  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    protected appConfig: AppConfiguration,
    public configuration: Configuration,
    private plycaErrorHandler: PlycaErrorHandler,
    public helpService: HelpService,
    public profileService: ProfileService,
    public userService: UserService
  ) {
    super(elem);
    this.waitService.startWaiting();
    this.subscribe(this.activatedRoute.params
      .pipe(tap(params => (this.identifier = params['id'])))
    );
    this.waitService.cancelWaiting();
    // this.canEdit = profileService.userHasEditGenericProject;
  }

  // ngOnInit() {
  // let profile = this.appConfig.getValue('infrastructurePlan.edition.profiles');
  // if (profile) {
  //   let ro = !this.userService.hasRoles(profile);
  // }
  // }

  ngAfterContentInit(): void {
    let profile = this.appConfig.getValue('infrastructurePlan.edition.profiles');
    if (profile) {
      this.readonly = !this.userService.hasRoles(profile);
    }
  }

  getFormSettingURL(): string {
    return 'infrastructurePlans/infrastructurePlanInterfaceSettings.json';
  }

  close() { }

  dtoToModel(dto: InfrastructurePlanDTO): Observable<InfrastructurePlanModel> {
    let model = new InfrastructurePlanModel();
    model.dto = dto;

    if (dto.name != null) {
      model.dto.name = dto.name;
    }

    if (dto.title != null) {
      model.dto.title = dto.title;
    }

    if (dto.contractFolderId != null) {
      model.dto.contractFolderId = dto.contractFolderId;
    }

    if (dto.startYear != null) {
      model.dto.startYear = dto.startYear;
    }
    if (dto.endYear != null) {
      model.dto.endYear = dto.endYear;
    }
    if (dto.agent != null) {
      model.dto.agent = dto.agent;
    }
    if (dto.approvalType != null) {
      model.dto.approvalType = dto.approvalType;
    }
    if (dto.resource != null) {
      model.dto.resource = dto.resource;
    }
    if (dto.discontinued != null) {
      model.dto.discontinued = dto.discontinued;
    }
    if (dto.remarks != null) {
      model.dto.remarks = dto.remarks;
    }
    if (dto.initialBudget != null) {
      model.dto.initialBudget = dto.initialBudget;
    }
    if (dto.finalBudget != null) {
      model.dto.finalBudget = dto.finalBudget;
    }
    if (dto.communityFinancing != null) {
      model.dto.communityFinancing = dto.communityFinancing;
    }
    if (dto.affectedFinancing != null) {
      model.dto.affectedFinancing = dto.affectedFinancing;
    }
    if (dto.title != null) {
      model.dto.title = dto.title;
    }

    // TODO faltaría el de la descripción. E igual también el de las anualidades.

    let modelObs: Observable<InfrastructurePlanModel>;
    modelObs = of(model);
    return modelObs;
  }

  modelToDTO(model: InfrastructurePlanModel): InfrastructurePlanDTO {
    // let dto: InfrastructurePlanDTO;
    // dto = lodash.cloneDeep(model.dto);
    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Planes de Infraestructuras';
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  getObjectIdentifier(): string {
    let identifier: string;
    if (this.task && this.task.work) {
      identifier = this.task.work.orderProject.identifier;
    } else if (this.identifier) {
      identifier = this.identifier;
    } else {
      // nuevo plan
      identifier = 'new';
    }
    return identifier;
  }


  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + 'infrastructurePlans/';
  }

  initHeaderActions() {
    if (!this.readonly) {
      this.subscribe(this.headerActionsService
        .addAction('Verificar', 'fas fa-check', 'btn-primary', true)
        , (() => {
          this.validateInfrastructurePlan();
        })
      );
      this.subscribe(this.headerActionsService
        .addAction('Guardar', 'fas fa-save', 'btn-primary', true)
        , (
          () => {
            if (this.task !== undefined) {

            } else {
              this.subscribe(this.validate(false), result => {
                if (result.result === ResultTypeDTO.ERROR) {
                  this.waitService.cancelWaiting();
                } else if (result.result === ResultTypeDTO.OK) {
                  this.subscribe(this.save(), _model => {
                    this.waitService.cancelWaiting();
                    if (_model) {
                      this.goToDossierInfo(_model)
                      // this.showConfirmMessage(_model);
                    } else {
                      this.goToDossierInfo(this.model.dto)
                      // this.showConfirmMessage(this.model.dto);
                    }
                  });
                } else {
                  // Error de validación FATAL
                  this.waitService.cancelWaiting();
                }
              }
              )
            }
          }
        )
      );
    }

    this.headerActionsService.addDivider();
    this.addBack();
  }

  goToDossierInfo(_infrastructurePlan: InfrastructurePlanDTO) {
    this.router.navigate(['dossierInfo/' + _infrastructurePlan.identifier], {
    });
  }


  protected addBack() {
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {
        if (this.task !== undefined) {

        }
        this.salir();
      }));
  }

  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.readonly = this.readonly;
    formConfig.functions.push({
      identifier: 'loadFinalBudget',
      fn: this.loadFinalBudget
    });

    return super.configureFormConfig(formConfig);
  }

  showConfirmMessage(_infrastructurePlan: InfrastructurePlanDTO) {
    this.uiService.showConfirmMessage({
      // ¿Desea iniciar la tramitación de la incidencia?
      message: this.translateService.instant('ContractModification.message_start_processing'),
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.waitService.startWaiting();
        this.subscribe(this.plycaService.insert(this.getServiceURL(), _infrastructurePlan)
          .pipe(
            finalize(() => {
              this.waitService.cancelWaiting();
            })
          ),
          () => {
            this.goToDossierInfo(_infrastructurePlan); // TODO no sé si necesito esto.
          },
          () => {
            console.log('Error');
          }
        );
      },
      reject: () => {
        this.goToDossierInfo(_infrastructurePlan); // TODO no sé si necesito esto.
        console.log('Saliendo...');
      }
    });
  }

  validateInfrastructurePlan() {

    this.subscribe(this.validate(), (result => {
      if (result.result === ResultTypeDTO.OK) {
        this.uiService.showMessage(
          'Se ha validado correctamente.',
          'Aviso',
          'errorStyle'
        );
      }
    }))
  }

  loadFinalBudget(model: any) {
    // TODO aquí if de si estamos en nuevo
    if (model.dto.initialBudget != null) {
      model.dto.finalBudget = model.dto.initialBudget;
    }
  }

}
